

// Only the four partners
const defaultPartners = [
  {
    name: "Lowe’s USA",
    description: "Ask us about our discounts when you shop at Lowe’s using our services",
    imageUrl: "",
  },
  {
    name: "Expedite Service Partners",
    description: "",
    imageUrl: "",
  },
  {
    name: "CMG container sales USA",
    description: "",
    imageUrl: "",
  },
  {
    name: "TD Bank",
    description: "",
    imageUrl: "",
  },
];

export default function PartnersSection({ partners = defaultPartners }) {
  if (!partners.length) return null;
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-8">Our Partners</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {partners.map((partner, idx) => (
            <div key={idx} className="bg-blue-50 rounded-xl p-6 flex flex-col items-center shadow border border-blue-100">
              {partner.imageUrl ? (
                <img src={partner.imageUrl} alt={partner.name} className="w-20 h-20 object-contain mb-4 rounded-full bg-white border" />
              ) : (
                <div className="w-20 h-20 mb-4 rounded-full bg-blue-100 flex items-center justify-center text-2xl font-bold text-blue-400 border">{partner.name[0]}</div>
              )}
              <h3 className="text-lg font-semibold text-blue-900 text-center mb-2">{partner.name}</h3>
              {partner.description && <p className="text-sm text-blue-700 text-center">{partner.description}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
